import { render } from "./RunFeed.vue?vue&type=template&id=fc3ca3f8&scoped=true&ts=true"
import script from "./RunFeed.vue?vue&type=script&lang=ts"
export * from "./RunFeed.vue?vue&type=script&lang=ts"

import "./RunFeed.vue?vue&type=style&index=0&id=fc3ca3f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3ca3f8"]])

export default __exports__